import React, { Component } from 'react'

export default class Gettypetype extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          packagingType: [
            { key: "1", text: "Dry Container", value: "1" },
            { key: "2", text: "Reefer Container", value: "2" },
            { key: "3", text: "Open Body", value: "3" },
          ],
          Name: "",
        };
      }

      async componentDidMount() {
        console.log(this.props.id);
        var name = this.state.packagingType.find(x => x.value == this.props.id);
        console.log(name);
        this.setState({
            Name: name
        })
      }

    render() {
        const { t } = this.props;
        const { Name } = this.state;
        return (
            <span>{Name ? Name.text : "NA"}</span>
        )
    }
}
